
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Reiseziel from '@/types/Reiseziel';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';
    import { DeleteReisezielPayload, ReisezieleFilter, UpdateReisezielPayload } from '@/store/reiseziele';
    import { LoadImpfempfehlungPayload } from '@/store/impfempfehlungen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('reiseziele', ['loaders']),
            ...mapState('impfempfehlungen', ['impfempfehlungen']),
            ...mapState('impfempfehlungen', { impfempfehlungenLoaders: 'loaders' }),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('reiseziele', ['loadReiseziele', 'editReiseziel', 'updateReiseziel', 'deleteReiseziel']),
            ...mapMutations('reiseziele', ['setDialogsDetail']),
            ...mapActions('impfempfehlungen', ['loadImpfempfehlungen']),
        },
    })
    export default class ReisezieleDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() reiseziel!: Reiseziel;
        @Prop() filter!: ReisezieleFilter;

        public $refs!: {
            form: VForm;
        };

        public updateReiseziel!: (payload: UpdateReisezielPayload) => void;
        public deleteReiseziel!: (payload: DeleteReisezielPayload) => void;
        public loadImpfempfehlungen!: (payload?: LoadImpfempfehlungPayload) => void;

        public get isEdit(): boolean {
            return this.reiseziel.reiseziel_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }

                this.loadImpfempfehlungen();
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateReiseziel({ reiseziel: this.reiseziel, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Reiseziel endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteReiseziel({ reiseziel: this.reiseziel, filter: this.filter });
                    }
                });
        }
    }
